export default __webpack_public_path__ + "static/media/liveCourseIcon.7c4c4e10.svg";